module.exports = {
  idle: 'idle',
  loading: 'loading',
  succeeded: 'succeeded',
  loadedFromCache: 'loadedFromCache',
  failed: 'failed',
};
